import {
  Flex, HStack, Link, Text,
} from '@chakra-ui/react';
import {
  useTerritorialActivityKPI,
} from '@src/modules/performance/context/reports-api-hooks';
import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import ReportHeader from './ReportHeader';

const subheader = 'Economic Activity';
const informationSource = {
  title: 'Territorial Activity',
  content: [
    {
      title: 'Population Growth (10 Year Annual Avg)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The average annual population growth for the latest ten years of data, including reporting the average as a percentage of the start year total population.
    </Text>
    <Text mb={2}>Road Efficiency Group Te Ringa Maimoa has calculated this result.</Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Stats NZ
    {' '}
    <Link href="https://www.stats.govt.nz/topics/population-estimates-and-projections/" isExternal>Population Estimates.</Link>
    {' '}
    Data sourced from
    {' '}
    <Link href="https://www.stats.govt.nz/tools/" isExternal>Stats NZ web tool</Link>
  </Text>,
    },
  ],
};

function TerritorialActivityReportHeader({ ...rest }) {
  const { data: territorialActivityData, isLoadingKpi } = useTerritorialActivityKPI();

  return (
    <ReportHeader
      title="Territorial Activity"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <HStack mr={3} spacing={0}>
          <CircleIndicator
            size={60}
            colour={territorialActivityData?.percentage !== undefined ? 'gray.700' : null}
            value={territorialActivityData?.percentage !== undefined ? `${roundKpiValue(territorialActivityData?.percentage, 10, 1, 'max')}%` : undefined}
            isLoading={isLoadingKpi || !territorialActivityData}
          />
          <Text>
            (
            {territorialActivityData?.value}
            )
          </Text>
        </HStack>
        <Text fontWeight="bold" color="gray" fontSize="sm">
          Population Growth
          <br />
          <Text as="span" fontSize="xs" color="gray">
            (
            {territorialActivityData?.averageYearRange}
            {' '}
            Annual Avg)
          </Text>
        </Text>
      </Flex>
    </ReportHeader>
  );
}

export default TerritorialActivityReportHeader;
